import React, { useEffect, useState } from "react";
import { Avatar, Col, Row } from "antd";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import FeatherIcon from "feather-icons-react";
import { InfoWraper, UserDropDwon } from "./auth-info-style";
import { Popover } from "../../popup/popup";
import { useSignOutGeneral } from "../../../hooks/generalFunction";
import MessengerNotificationBell from "./messenger-notification-bell";
import { subscribeToPush, unsubscribeFromPush } from "../../../config/api/messengerService";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

function AuthInfo() {
  const userData = useSelector((state) => state.auth);

  const [pushEnabled, setPushEnabled] = useState(false);
  const [pushBusy, setPushBusy] = useState(false);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    navigator.serviceWorker.ready
      .then((reg) => reg.pushManager.getSubscription())
      .then((sub) => setPushEnabled(!!sub))
      .catch(() => {});
  }, []);

  const signOut = useSignOutGeneral();

  const SignOut = async (e) => {
    e.preventDefault();
    //logout aws session
    signOut();
  };

  const handleTogglePush = async (e) => {
    e.preventDefault();
    if (pushBusy) return;
    setPushBusy(true);
    try {
      const registration = await navigator.serviceWorker.ready;
      if (pushEnabled) {
        const subscription = await registration.pushManager.getSubscription();
        if (subscription) {
          await unsubscribeFromPush(subscription.endpoint);
          await subscription.unsubscribe();
        }
        setPushEnabled(false);
      } else {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") return;
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(process.env.REACT_APP_VAPID_PUBLIC_KEY),
        });
        const json = subscription.toJSON();
        if (json.endpoint && json.keys?.p256dh && json.keys?.auth) {
          await subscribeToPush({ endpoint: json.endpoint, keys: { p256dh: json.keys.p256dh, auth: json.keys.auth } });
          setPushEnabled(true);
        }
      }
    } catch (err) {
      console.error("Failed to toggle push notifications:", err);
    } finally {
      setPushBusy(false);
    }
  };

  const userContent = (
    <UserDropDwon>
      <div className="user-dropdwon">
        <Link
          to="#"
          onClick={handleTogglePush}
          style={{
            display: "flex",
            gap: "5px",
            alignItems: "center",
            fontSize: "12px",
            marginBottom: "8px"
          }}>
          <FeatherIcon icon="bell" size={14} />
          {pushBusy ? "Please wait…" : pushEnabled ? "Disable message notifications" : "Enable message notifications"}
        </Link>
        <Link
          to="#"
          onClick={SignOut}
          style={{
            display: "flex",
            gap: "5px",
            alignItems: "center",
            fontSize: "12px"
          }}>
          <FeatherIcon icon="log-out" size={14} /> Sign Out
        </Link>
      </div>
    </UserDropDwon>
  );

  return (
    <InfoWraper>
      <div className="nav-author" style={{ display: "flex", alignItems: "center" }}>
        <MessengerNotificationBell />
        <Popover placement="bottomRight" content={userContent} action="click">
          <Row style={{ alignItems: "center", gap: "5px" }}>
            <Col>
              <a href="#" style={{ fontSize: "13px", color: "#000" }}>
                {userData?.userData?.loginId || "N/A"}
              </a>
            </Col>
            <Col>
              <Link to="#" className="head-example">
                <Avatar src="https://cdn0.iconfinder.com/data/icons/user-pictures/100/matureman1-512.png" />
              </Link>
            </Col>
          </Row>
        </Popover>
      </div>
    </InfoWraper>
  );
}

export default AuthInfo;
